define('glu/appBus',['require','backbone.wreqr'],function(require) {
    'use strict';

    var Wreqr = require('backbone.wreqr');
    return new Wreqr.EventAggregator();
});

